import { useSelector } from 'react-redux'

import { tileEntityAllIdsSelector, tileEntityByIdSelector } from 'client/store/tileEntity'
import { ProductStructuredDataWriter } from 'client/components/Gallery/ProductStructuredData/ProductStructuredDataWriter'
import { getMetadata } from 'client/store/config/reducer'
import { useSocialMediaGallery } from 'client/hooks/useSocialMediaGallery'
import { useMemo } from 'react'
import { PREVIEWS_AMOUNT } from './data'
import { BreadcrumbListStructuredDataWriter } from './BreadcrumbListStructuredDataWriter'

export const ProductStructuredData = () => {
  const shouldHideForSocialMedia = useSocialMediaGallery()
  const allEntities = useSelector(tileEntityAllIdsSelector)
  const galleryMetadata = useSelector(getMetadata)
  const getEntityById = useSelector(tileEntityByIdSelector)

  const entities = useMemo(() => allEntities.slice(0, PREVIEWS_AMOUNT).map(getEntityById), [allEntities, getEntityById])

  // hide product-structured-data for social media gallery
  const shouldRenderWriter = !shouldHideForSocialMedia && !!entities?.length && galleryMetadata

  return (
    <>
      {<BreadcrumbListStructuredDataWriter />}
      {shouldRenderWriter && <ProductStructuredDataWriter entities={entities} galleryMetadata={galleryMetadata} />}
    </>
  )
}
